import { createStyles } from "antd-style";
import { formPrefixCls } from "@/base/index";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  root: css``,
  input: css`
    .${formPrefixCls}-item-feedback-icon {
      pointer-events: fill;
      cursor: help;
    }
  `,
}));

export const useSharedFormItemAccountNumberStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
